"use client";

import type {ComponentProps} from "react";
import {
	getPortableTextComponents,
	type GetPortableTextComponentsOptions,
} from "@repo/ui/aops-components/portable-text-components";
import {PortableText} from "next-sanity";
import styles from "./PortableTextComponents.module.css";

const aopsClassNames: GetPortableTextComponentsOptions["classNames"] = {
	paragraph: styles.paragraph,
	heading: styles.heading,
	list: styles.list,
	listItem: styles.listItem,
	listNumber: styles.listNumber,
	listItemNumber: styles.listItemNumber,
};

const aopsPortableTextComponents = getPortableTextComponents({
	classNames: aopsClassNames,
}) as ComponentProps<typeof PortableText>["components"];

type PortableTextValue = ComponentProps<typeof PortableText>["value"];

type AopsPortableTextProps = {
	value: PortableTextValue;
	className?: string;
};

export function AopsPortableText({value, className}: AopsPortableTextProps) {
	const classNames = [styles.portableText, className].filter(Boolean).join(" ");

	return (
		<div className={classNames}>
			<PortableText value={value} components={aopsPortableTextComponents} />
		</div>
	);
}
